// ** Redux & Store & Actions
import { useDispatch } from "react-redux";
import { setAge } from "store/modules/auth";

// ** Custom Components
import Block from "components/layout/Block";
import SelectorDay from "../SelectorDay";
import SelectorMonth from "../SelectorMonth";
import SelectorYear from "../SelectorYear";

// ** Custom Hooks
import useSelectorDay from "hooks/selectors/useSelectorDay";
import useSelectorMonth, {
	compute as monthCompute,
} from "hooks/selectors/useSelectorMonth";
import useSelectorYear from "hooks/selectors/useSelectorYear";

// ** Styles Import
import { ButtonGroup } from "containers/Landing/components/ButtonGroup";

// #####################################################

const AgeContent = ({
	selectedDay,
	selectedMonth,
	selectedYear,
	setShowAgeEmptyMessage,
}) => {
	const dispatch = useDispatch();

	// **
	const selectorDay = useSelectorDay({ initial: selectedDay });
	const selectorMonth = useSelectorMonth({
		initial: monthCompute.codeToValue(selectedMonth),
	});
	const selectorYear = useSelectorYear({ initial: selectedYear });

	// **
	const handleSelectAge = ({ day, month, year }) => {
		setShowAgeEmptyMessage(false);
		dispatch(setAge({ day, month, year }));
	};

	// #####################################################

	return (
		<Block flex column mb={2}>
			<ButtonGroup>
				<SelectorDay
					selectorDay={selectorDay}
					onAccept={(day) => {
						handleSelectAge({ day });
					}}
				/>
				<SelectorMonth
					selectorMonth={selectorMonth}
					onAccept={(month) => {
						handleSelectAge({
							month: selectorMonth.compute.valueToApiParam(month),
						});
					}}
				/>
				<SelectorYear
					selectorYear={selectorYear}
					onAccept={(year) => {
						handleSelectAge({ year });
					}}
				/>
			</ButtonGroup>
		</Block>
	);
};

// #####################################################

export default AgeContent;

// #####################################################
